import {Component,Inject,OnInit} from '@angular/core';
import {Bareme} from "@domain/prestation/bareme";
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,MatLegacyDialogRef as MatDialogRef} from "@angular/material/legacy-dialog";
import {PrestationService} from "@services/admin/frais/prestation.service";
import {ToastrService} from "ngx-toastr";
import {TranslateService} from "@ngx-translate/core";
import {ConfirmService} from "@share/component/confirmation/confirm.service";
import {filter,finalize,first} from "rxjs/operators";
import {Result,TypeCodeErreur} from "@domain/common/http/result";
import * as moment from "moment/moment";
import {Montant} from "@domain/prestation/montant";
import {TypeBareme} from "@domain/prestation/TypeBareme";
import {BaremeDetailPopinComponent} from "@components/admin/frais/prestations/prestation-detail/regles-gestion/bareme-detail-popin.component";

/**
 * Composant d'affichage du détail d'un montant
 *
 * @author Lionel Gimenez
 * @date 06/01/2026
 */
@Component({
    host: {'data-test-id': 'montant-detail'},
    templateUrl: './montant-detail.component.html'
})
export class MontantDetailComponent implements OnInit {
    /** Montant */
    montant: Montant;

    /** Chargement en cours */
    isPending: boolean;

    /** Indique si on est en création */
    isCreation: boolean = false;

    /**
     * Constructeur
     */
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            montant: Montant,
            isCreation: boolean,
        },
        private prestationService: PrestationService,
        private matDialogRef: MatDialogRef<BaremeDetailPopinComponent>,
        private toastrService: ToastrService,
        private translateService: TranslateService,
        private confirmService: ConfirmService
    ) {
    }

    /**
     * Initialisation du composant
     */
    ngOnInit(): void {
        //Récupération du barème
        this.montant = new Montant(this.data.montant);

        //Récupération de l'indicateur de création
        this.isCreation = this.data.isCreation ?? false;
    }

    /**
     * Clic sur le bouton d'enregistrement
     */
    onSave(): void {
        //Chargement en cours
        this.isPending = true;

        //Appel au service
        this.prestationService.saveMontant(this.montant)
            .pipe(first(),finalize(() => this.isPending = false))
            .subscribe((result: Result) => {
                //Vérification du code d'erreur
                if (result.codeErreur === TypeCodeErreur.NO_ERROR) {
                    //Toast succès
                    this.toastrService.success(this.translateService.instant('global.success.enregistrement'));

                    //Fermeture de la popup
                    this.matDialogRef.close(true);
                } else {
                    //Gestion de l'erreur
                    TypeCodeErreur.showError(result.codeErreur,this.translateService,this.toastrService);
                }
            });
    }

    /**
     * Suppression d'un montant
     */
    onDelete(): void {
        //Confirmation auprès de l'utilisateur sur la suppression d'un montant
        this.confirmService.showConfirm(this.translateService.instant('global.suppression.confirmation'))
            .pipe(filter(isConfirmed => isConfirmed))
            .subscribe({
                next: () => {
                    //Chargement en cours
                    this.isPending = true;

                    //Appel au service
                    this.prestationService.deleteMontant(this.montant)
                        .pipe(first(),finalize(() => this.isPending = false))
                        .subscribe((result: Result) => {
                            //Vérification du code d'erreur
                            if (result.codeErreur === TypeCodeErreur.NO_ERROR) {
                                //Toast succès
                                this.toastrService.success(this.translateService.instant('global.success.suppression'));

                                //Fermeture de la popup
                                this.matDialogRef.close(true);
                            } else {
                                //Gestion de l'erreur
                                TypeCodeErreur.showError(result.codeErreur,this.translateService,this.toastrService);
                            }
                        });
                }
            });
    }
}
